import { MutationTree } from 'vuex'
import { INavigationState } from './types'

const mutations: MutationTree<INavigationState> = {
    reset(state) {
        state.activeTopLevelIndex = null,
        state.secondLevelIsOpen = false,
        state.activeSecondLevelIndex = null,
        state.eventsPanelIsOpen = false
    },

    setSecondLevelOpen(state, value) {
        state.secondLevelIsOpen = value
    },

    setActiveTopLevelItem(state, value) {
        state.activeTopLevelIndex = value
    },

    setActiveSecondLevelItem(state, value) {
        state.activeSecondLevelIndex = value
    },

    setEventsPanelOpen(state, value) {
        state.eventsPanelIsOpen = value
    },

    setNavData(state, value): any {
        state.navData = value
    },

    setEventsData(state, value): any {
        state.eventsData = value
    },
}

export default mutations

